module.exports = __webpack_public_path__ + "img/Google.94b46c1.svg";